import { GetAddressProposalFragment } from './getAddress.generated-types'

export const getAddress = (proposal: GetAddressProposalFragment): string | undefined => {
  if (proposal?.space?.venue == null) return undefined

  const { addressLine1, city, postalCode } = proposal.space.venue

  return `${addressLine1}, ${city ? city + ', ' : ''}${postalCode}`
}
